import { FlatList, VStack } from "native-base";
import React from "react";

import CartFloatingButton from "@/components/atoms/CartFloatingButton";
import MobileHeader from "@/components/molecules/MobileHeader";
import Container from "@/components/organisms/Container";
import ProductSectionList from "@/components/organisms/ProductSectionList";
import ProductSectionListLoading from "@/components/organisms/ProductSectionList/ProductSectionListLoading";
import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { HomeNavigation } from "@/navigation/stacks/HomeStack";

import { HallCategoryListScreenProps } from "./types";

const HallCategoryListMobile = ({
  categoryList,
  hall,
  hallList,
  isLoading,
  onPressViewMore,
  onSelectProduct,
  onGoBack,
  onSelectHall,
}: HallCategoryListScreenProps) => {
  const { height } = useViewport();
  const { navigate } = useAppNavigation<HomeNavigation>();

  return (
    <>
      <Container
        px="1"
        pt="2"
        Header={
          <MobileHeader
            title={hall?.nome || "Carregando..."}
            subtitle="Categorias"
            badgeList={hallList}
            showLogo={false}
            showSearch={true}
            onBackPress={onGoBack}
            activeBadgeId={hall?._id}
            onSelectBadge={(item) => onSelectHall(item?._id)}
            onPressSearch={() => navigate("inStoreSearch", { storeId: hall?.estabelecimento })}
          />
        }>
        <VStack w="100%" h={height + "px"}>
          {isLoading && (
            <ProductSectionListLoading
              showDivider={false}
              shadow="none"
              p={0}
              my="1"
              rounded="none"
            />
          )}
          <FlatList
            data={categoryList}
            nestedScrollEnabled
            keyExtractor={(item, index) => (item ? item._id : index.toString())}
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{
              paddingBottom: 96,
            }}
            renderItem={({ item: category }) => (
              <ProductSectionList
                shadow="none"
                p={0}
                my="1"
                rounded="none"
                title={category.nome}
                data={category.produtos}
                isLoading={isLoading}
                showDivider={false}
                onSelect={onSelectProduct}
                onPressViewMore={() => onPressViewMore(category?._id)}
              />
            )}
          />
        </VStack>
      </Container>
      <CartFloatingButton />
    </>
  );
};

export default HallCategoryListMobile;
